// src/WeeklyCalendarView.js - LOGICA DI MODIFICA CORRETTA E POTENZIATA

import React, { useState, useEffect, useCallback } from 'react';
import moment from 'moment';
import 'moment/locale/it';
import { db } from './firebase';
import { collection, getDocs, addDoc, deleteDoc, doc, updateDoc, setDoc, getDoc, writeBatch, query, where, deleteField } from 'firebase/firestore';
import { ConfirmationModal } from './Modals';
import { AssignmentModal } from './AssignmentModal'
import Select from 'react-select';
import { ChoiceModal } from './Modals';
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaCalendarAlt } from 'react-icons/fa';
import it from 'date-fns/locale/it';
import { useUser } from './UserContext';
import Holidays from 'date-holidays';
import { logAction } from './loggingService';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

registerLocale('it', it);
const hd = new Holidays('IT');

// --- FUNZIONE HELPER PER GENERARE DATE RICORRENZA ---
const generateRecurrenceDates = (data) => {
    const dates = [];
    // Se non è ricorrente, controlla solo le date valide nel range
    if (!data.isRecurring) {
        let current = moment(data.validFrom);
        const end = moment(data.validUntil);
        while (current.isSameOrBefore(end)) {
            if ((data.daysOfWeek || []).includes(current.isoWeekday())) {
                 if (!(data.excludedDates || []).includes(current.format('YYYY-MM-DD'))) {
                    dates.push(current.clone());
                }
            }
            current.add(1, 'day');
        }
        return dates;
    }

    // Se è ricorrente
    let current = moment(data.validFrom);
    const end = moment(data.validUntil);
    const daysOfWeek = data.daysOfWeek || [];
    const interval = parseInt(data.recurrenceInterval || 1);
    
    const startOfWeek = moment(data.validFrom).startOf('isoWeek');

    while (current.isSameOrBefore(end)) {
        if (daysOfWeek.includes(current.isoWeekday())) {
            const weeksDiff = current.clone().startOf('isoWeek').diff(startOfWeek, 'weeks');
            if (weeksDiff % interval === 0) {
                if (!(data.excludedDates || []).includes(current.format('YYYY-MM-DD'))) {
                    dates.push(current.clone());
                }
            }
        }
        current.add(1, 'day');
    }
    return dates;
};

// --- MODALE CONFLITTO (MODIFICATO) ---
const OverlapSuggestionModal = ({ isOpen, onClose, conflictData, onSelectAlternative, rooms, doctors }) => {
    const [selectedAlternativeRoomId, setSelectedAlternativeRoomId] = useState('');

    useEffect(() => {
        if (isOpen && conflictData?.alternatives?.length > 0) {
            setSelectedAlternativeRoomId('');
        }
    }, [isOpen, conflictData]);

    const customSelectStyles = {
        option: (provided, state) => {
            const { isSuitable } = state.data;
            if (isSuitable) return { ...provided, fontWeight: 'bold', color: '#198754' };
            return { ...provided, backgroundColor: '#fff3cd', color: '#664d03', fontWeight: 'bold' };
        },
        menuPortal: base => ({ ...base, zIndex: 99999 })
    };

    if (!isOpen || !conflictData) return null;

    // Estrai anche customWarning e conflictDate
    const { assignmentData, alternatives, isSwap, targetRoomName, customWarning } = conflictData;

    const getDoctorName = (docId) => {
        const doctor = Array.isArray(doctors) ? doctors.find(d => d.id === docId) : null;
        return doctor ? `${doctor.firstName} ${doctor.lastName}` : 'N/D';
    };
    const doctorName = getDoctorName(assignmentData.doctorId);

    const handleConfirmAlternative = () => {
        if (!selectedAlternativeRoomId) {
            toast.warn("Seleziona una stanza alternativa prima di inserire.");
            return;
        }
        onSelectAlternative(selectedAlternativeRoomId);
    };

    // Opzione per FORZARE (usando la stanza originale)
    const handleForceInsert = () => {
        onSelectAlternative(assignmentData.roomId);
    };

    const alternativeOptions = Array.isArray(alternatives) ? alternatives.map(room => ({
        value: room.id,
        label: room.isSuitable 
            ? `✅ ${room.name} (Idonea)` 
            : `⚠️ ${room.name} (Non idonea - Manca: ${room.missing || 'attrezzatura'})`,
        isSuitable: room.isSuitable,
        missing: room.missing
    })) : [];

    return (
        <div className="modal" onMouseDown={onClose}>
            <div className="modal-content" onMouseDown={e => e.stopPropagation()}>
                <h3>⚠️ Sovrapposizione Rilevata!</h3>
                
                {/* MESSAGGIO DINAMICO */}
                <div style={{ textAlign: 'left', marginBottom: '15px', borderLeft: '4px solid #d0021b', paddingLeft: '10px', backgroundColor: '#fff5f5', padding: '10px' }}>
                    {customWarning ? (
                        <p style={{fontWeight: 'bold', color: '#d0021b', margin: 0}}>{customWarning}</p>
                    ) : (
                        <p>
                            L'appuntamento per <strong>{doctorName}</strong>
                            ({assignmentData.startTime} - {assignmentData.endTime})
                            non può essere inserito nella stanza "{targetRoomName}" perché occupata.
                        </p>
                    )}
                </div>

                <div style={{marginBottom: '20px', textAlign: 'left'}}>
                    <p style={{fontSize: '0.9rem', color: '#666'}}>Opzioni disponibili:</p>
                    
                    {/* PULSANTE FORZA INSERIMENTO */}
                    <button 
                        onClick={handleForceInsert}
                        className="modal-button warning-button"
                        style={{width: '100%', marginBottom: '15px', fontWeight: 'bold'}}
                    >
                        ⚠️ Inserisci lo stesso (Sovrapponi)
                    </button>

                    <hr style={{margin: '15px 0', border: '0', borderTop: '1px solid #eee'}} />

                    <label style={{ fontWeight: 'bold', display: 'block', marginBottom: '8px' }}>
                        Oppure cambia stanza (SOLO per questa data):
                    </label>
                    
                    {alternativeOptions.length > 0 ? (
                        <>
                            <Select
                                options={alternativeOptions}
                                value={alternativeOptions.find(opt => opt.value === selectedAlternativeRoomId)}
                                onChange={(selectedOption) => setSelectedAlternativeRoomId(selectedOption ? selectedOption.value : '')}
                                placeholder="Scegli una stanza alternativa..."
                                classNamePrefix="react-select"
                                styles={customSelectStyles}
                                menuPortalTarget={document.body}
                            />
                            <button
                                onClick={handleConfirmAlternative}
                                className="modal-button confirm-button"
                                style={{ width: '100%', marginTop: '10px' }}
                                disabled={!selectedAlternativeRoomId}
                            >
                                Sposta in questa stanza (Crea Eccezione)
                            </button>
                        </>
                    ) : (
                        <p style={{ color: 'red', fontStyle: 'italic' }}>Nessuna stanza alternativa disponibile.</p>
                    )}
                </div>

                <button onClick={onClose} className="modal-button cancel-button">
                    Annulla Operazione
                </button>
            </div>
        </div>
    );
};

const Tooltip = ({ content, position }) => {
    if (!content) return null;
    const style = {
        position: 'fixed',
        top: position.y,
        left: position.x,
        transform: 'translate(-50%, -110%)',
        backgroundColor: '#333',
        color: 'white',
        padding: '8px 12px',
        borderRadius: '6px',
        zIndex: 800,
        whiteSpace: 'pre',
        fontSize: '0.75rem',
        pointerEvents: 'none',
        textAlign: 'left',
    };
    return <div style={style}>{content}</div>;
};

const portalStyles = {
    menuPortal: base => ({ ...base, zIndex: 9999 })
};

const useAccordion = (initialState = {}) => {
    const [openAccordions, setOpenAccordions] = useState(initialState);
    const toggleAccordion = (id) => setOpenAccordions(prev => ({ ...prev, [id]: !prev[id] }));
    const openSingleAccordion = (id) => setOpenAccordions({ [id]: true });
    return [openAccordions, toggleAccordion, openSingleAccordion];
};

// 🆕 Converte "HH:MM" in minuti
const hhmmToMin = (t) => {
    if (!t || typeof t !== 'string') return 0;
    const [h, m] = t.split(':').map(Number);
    return (h || 0) * 60 + (m || 0);
};

// 🆕 Dato un assignment (turno) e la lista sedute chiuse, ritorna lo stato di chiusura:
//    { state: 'open' | 'partial' | 'full', intervals: [...] }
const getClosureStatus = (assignment, dayStr, closedSessionsList) => {
    const sessionKey = `${assignment.roomId}_${assignment.doctorId}_${dayStr}`;
    const sessionDoc = closedSessionsList.find(s => s.id === sessionKey);
    if (!sessionDoc) return { state: 'open', intervals: [] };

    const intervals = Array.isArray(sessionDoc.closedIntervals) ? sessionDoc.closedIntervals : null;

    // Legacy: documento senza closedIntervals = chiusura totale
    if (!intervals || intervals.length === 0) return { state: 'full', intervals: [] };

    const shiftStart = hhmmToMin(assignment.startTime);
    const shiftEnd = hhmmToMin(assignment.endTime);

    // Totale se un intervallo copre l'intera fascia del turno
    const isFull = intervals.some(iv =>
        hhmmToMin(iv.startTime) <= shiftStart && hhmmToMin(iv.endTime) >= shiftEnd
    );

    return { state: isFull ? 'full' : 'partial', intervals };
};


function WeeklyCalendarView() {
    const { userProfile } = useUser();
    const permissionLevel = userProfile?.permissions?.rooms || 'none';
    const canEdit = permissionLevel === 'completo' || permissionLevel === 'semi-completo';
    const [allEquipment, setAllEquipment] = useState([]);
    // Stati
    const [currentWeek, setCurrentWeek] = useState(moment().startOf('isoWeek'));
    const [isLoading, setIsLoading] = useState(true);
    const [rooms, setRooms] = useState([]);
    const [doctors, setDoctors] = useState([]);
    const [assignments, setAssignments] = useState([]);
    const [services, setServices] = useState([]); // 🎯 FIX 1A: Stato per le prestazioni
    const [businessHours, setBusinessHours] = useState({});
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalData, setModalData] = useState({ day: null, assignment: null });
    const [openAccordions, toggleAccordion, openSingleAccordion] = useAccordion({ [moment().isoWeekday() - 1]: true });
    const [specialties, setSpecialties] = useState([]);
    const [monthlyAssignments, setMonthlyAssignments] = useState([]);
    const [lastFetchedMonth, setLastFetchedMonth] = useState(null);
    const [monthlyShifts, setMonthlyShifts] = useState({});
    const [closedRooms, setClosedRooms] = useState({});
    const [roomClosureModal, setRoomClosureModal] = useState({ isOpen: false, room: null, day: null });
    const [summaryData, setSummaryData] = useState({});
    const [isSummaryOpen, setIsSummaryOpen] = useState(false);
    const [scrollToDate, setScrollToDate] = useState(null);
    const [tooltip, setTooltip] = useState({ visible: false, content: '', x: 0, y: 0 });
    const [filteredDoctor, setFilteredDoctor] = useState(null);
    const [filteredSpecialty, setFilteredSpecialty] = useState(null);
    const [choiceModal, setChoiceModal] = useState({ isOpen: false, action: null, data: null });
    const [swapState, setSwapState] = useState({ active: false, sourceAssignment: null, sourceDay: null });
    // 🆕 Copia/Incolla Prestazioni: stesso pattern dello Scambio Stanza, ma
    // molto più semplice — non tocca medico/orario/stanza, solo l'elenco
    // delle prestazioni consentite (allowedServices).
    const [copyServicesState, setCopyServicesState] = useState({ active: false, sourceAssignment: null });
    const [pasteServicesConfirm, setPasteServicesConfirm] = useState({ isOpen: false, targetAssignment: null });
    const [closedSessionsList, setClosedSessionsList] = useState([]);

    // --- STATO MODALE SOVRAPPOSIZIONE ---
    const [overlapModalState, setOverlapModalState] = useState({
        isOpen: false,
        conflictData: null
    });

    // --- STATO MODALE AVVISO MACCHINARI IN SWAP MODE ---
    // Si apre quando l'utente sceglie una stanza senza i macchinari richiesti
    const [swapEquipmentWarning, setSwapEquipmentWarning] = useState({
        isOpen: false,
        missingEquipment: [],  // [{id, name}] macchinari mancanti nella stanza target
        pendingTarget: null,   // il target originale da passare a handleTargetSlotClick
    });

    const isTimeOverlapping = (start1, end1, start2, end2) => {
    const s1 = moment(start1, 'HH:mm').diff(moment().startOf('day'), 'minutes');
    const e1 = moment(end1, 'HH:mm').diff(moment().startOf('day'), 'minutes');
    const s2 = moment(start2, 'HH:mm').diff(moment().startOf('day'), 'minutes');
    const e2 = moment(end2, 'HH:mm').diff(moment().startOf('day'), 'minutes');
    return s1 < e2 && e1 > s2;
};

    const fetchData = useCallback(async () => {
        if (!userProfile || !userProfile.centerId) {
    setIsLoading(false);
    setRooms([]);
    return; // Esci se non c'è un centro
}
const centerId = userProfile.centerId;
        setIsLoading(true);
        const monthId = currentWeek.format('YYYY-MM');
        const weekStartStr = currentWeek.clone().startOf('isoWeek').format('YYYY-MM-DD');
        const weekEndStr = currentWeek.clone().endOf('isoWeek').format('YYYY-MM-DD');

        const assignmentsQuery = query(collection(db, 'centers', centerId, "roomAssignments"), where("validUntil", ">=", weekStartStr)); // <-- MODIFICA QUI

    // Ottieni tutti i dati in parallelo
    const [roomsSnap, doctorsSnap, specialtiesSnap, equipmentSnap, assignmentsSnap, hoursSnap, shiftsSnap, closedRoomsSnap, closedSessionsSnap, servicesSnap] = await Promise.all([
            getDocs(collection(db, 'centers', centerId, "rooms")), 
            getDocs(collection(db, 'centers', centerId, "doctors")), 
            getDocs(collection(db, 'centers', centerId, "specialties")), 
            getDocs(collection(db, 'centers', centerId, "equipment")), 
            getDocs(assignmentsQuery), 
            getDoc(doc(db, 'centers', centerId, "settings", "businessHours")), 
            getDoc(doc(db, 'centers', centerId, "schedules", monthId)), 
            getDoc(doc(db, 'centers', centerId, "roomStatus", monthId)), 
            getDocs(collection(db, 'centers', centerId, "closedSessions")), // <--- Chiamata
            getDocs(collection(db, 'centers', centerId, "services"))
        ]);

        // Estrai dati
        const closedRoomsData = closedRoomsSnap.exists() ? closedRoomsSnap.data() : {};
        const shiftsData = shiftsSnap.exists() ? JSON.parse(shiftsSnap.data().schedule) : {};
        const hoursData = hoursSnap.exists() ? hoursSnap.data() : {};
        const equipmentList = equipmentSnap.docs.map(d => ({ id: d.id, ...d.data() })); // <-- Salva i macchinari
        const specialtiesList = specialtiesSnap.docs.map(d => ({ id: d.id, ...d.data() }));
        // 🆕 Oggetti completi (id + closedIntervals), non solo gli id: servono per distinguere
        // chiusura totale da chiusura parziale a fasce.
        const closedSessionsData = closedSessionsSnap.docs.map(d => ({ id: d.id, ...d.data() }));
        

        // Ordina stanze per numero
        const roomsList = roomsSnap.docs.map(d => ({
            id: d.id,
            ...d.data(),
            equipmentNames: (d.data().equipmentIds || []).map(id => equipmentList.find(e => e.id === id)?.name).filter(Boolean)
        })).sort((a, b) => (a.number || 0) - (b.number || 0));

        // Mappa dottori e specialistiche
        const doctorsList = doctorsSnap.docs.map(d => ({
            id: d.id,
            ...d.data(),
            // Aggiungi l'oggetto specialità completo invece del solo ID
            specialties: (d.data().specialtyIds || []).map(id => specialtiesList.find(s => s.id === id)).filter(Boolean)
        })).sort((a, b) => a.lastName.localeCompare(b.lastName)); // Ordina per cognome


        // Filtra e arricchisci assegnazioni della settimana
        const assignmentsList = assignmentsSnap.docs
            .map(d => ({ id: d.id, ...d.data() }))
            .filter(a => a.validFrom <= weekEndStr) // Prendi quelle valide fino alla fine della settimana
            .map(data => {
                const room = roomsList.find(r => r.id === data.roomId);
                const doctor = doctorsList.find(d => d.id === data.doctorId);
                // Cerca le specialistiche complete del dottore
                const doctorSpecialties = doctor?.specialties || [];
                return {
                    ...data,
                    roomName: room?.name || 'N/A',
                    doctorName: doctor ? `${doctor.firstName} ${doctor.lastName}` : 'N/A',
                    doctorSpecialties: doctorSpecialties // Usa l'array di oggetti
                };
             });


        // Recupera assegnazioni mensili SE necessario (per calcolo summary)
        if (monthId !== lastFetchedMonth) {
            const monthStartStr = currentWeek.clone().startOf('month').format('YYYY-MM-DD');
            const monthEndStr = currentWeek.clone().endOf('month').format('YYYY-MM-DD');
            // Usiamo una query più ampia per sicurezza, filtrando poi in locale
            const monthlyAssignmentsQuery = query(collection(db, 'centers', centerId, "roomAssignments"), where("validUntil", ">=", monthStartStr)); // <-- MODIFICA QUI
            const monthlyAssignmentsSnap = await getDocs(monthlyAssignmentsQuery);
            const monthlyAssignmentsList = monthlyAssignmentsSnap.docs
                .map(doc => ({ id: doc.id, ...doc.data() }))
                .filter(assignment => assignment.validFrom <= monthEndStr); // Filtra quelle che iniziano entro la fine del mese
            setMonthlyAssignments(monthlyAssignmentsList);
            setLastFetchedMonth(monthId);
        }

        // Aggiorna stati
        setClosedRooms(closedRoomsData);
        setMonthlyShifts(shiftsData);
        setBusinessHours(hoursData);
        setRooms(roomsList);
        setDoctors(doctorsList); // Assicurati che questo stato sia aggiornato
        setSpecialties(specialtiesList); // Assicurati che questo stato sia aggiornato
        setAllEquipment(equipmentList);
        setServices(servicesSnap.docs.map(d => ({ id: d.id, ...d.data() })));
        setAssignments(assignmentsList);
        setIsLoading(false);
        setClosedSessionsList(closedSessionsData);

        // 🎯 FIX CHIRURGICO: Se l'utente è un medico, forza subito il filtro su se stesso
        if (userProfile?.isDoctorProfile && !filteredDoctor) {
            const myDoctorRecord = doctorsList.find(d => d.authUid === userProfile.uid);
            if (myDoctorRecord) {
                setFilteredDoctor({ value: myDoctorRecord.id, label: `${myDoctorRecord.firstName} ${myDoctorRecord.lastName}` });
            }
        }
    }, [currentWeek, userProfile]);


    useEffect(() => { fetchData(); }, [fetchData, lastFetchedMonth]); // <-- MODIFICA QUI

    const isRoomClosedOnDay = useCallback((roomId, day) => {
        const dayStr = day.format('YYYY-MM-DD');
        return closedRooms[dayStr] && closedRooms[dayStr].includes(roomId);
    }, [closedRooms]);

    // SOSTITUISCI LA VECCHIA FUNZIONE findAlternativeRooms (righe 326-382) CON QUESTA:
    // Cerca stanze alternative libere e attrezzate per le prestazioni del turno.
    // Logica: controlla solo i requiredEquipmentId delle prestazioni abilitate
    // (allowedServices). Se nessuna prestazione richiede macchinari, tutte le
    // stanze libere nell'orario sono considerate idonee.
    const findAlternativeRooms = (
        doctorId, targetDayMoment, startTime, endTime,
        excludedRoomId, currentAssignments, allRooms,
        allDoctors, allSpecialtiesList, allEquipmentList,
        allowedServiceIds = [], allServices = []
    ) => {
        const alternativeRooms = [];

        // 1. Costruisco il set dei macchinari richiesti dalle prestazioni del turno
        //    (stesso algoritmo del controllo in AssignmentModal)
        const requiredEquipmentIds = new Set();

        if (allowedServiceIds.length > 0) {
            allowedServiceIds.forEach(serviceId => {
                const service = allServices.find(s => s.id === serviceId);
                if (!service || !service.requiredEquipmentId) return;

                const equipment = allEquipmentList.find(
                    e => e.id === service.requiredEquipmentId
                );
                if (equipment) requiredEquipmentIds.add(equipment.id);
            });
        }

        // 2. Scorro tutte le stanze cercando alternative valide
        let currentDate = moment(targetDayMoment).startOf('day');
        const dayOfWeek = currentDate.isoWeekday();
        const dayStr = currentDate.format('YYYY-MM-DD');

        for (const room of allRooms) {
            // Escludo la stanza corrente (già risultata non idonea)
            if (room.id === excludedRoomId) continue;
            // Escludo le stanze chiuse in quel giorno
            if (isRoomClosedOnDay(room.id, currentDate)) continue;

            // 3. Controllo disponibilità oraria
            const existingAssignmentsInRoom = currentAssignments.filter(a => {
                if (a.roomId !== room.id) return false;
                if (!(a.daysOfWeek || []).includes(dayOfWeek)) return false;
                if ((a.excludedDates || []).includes(dayStr)) return false;
                const isValidDate = currentDate.isBetween(
                    a.validFrom, a.validUntil, 'day', '[]'
                );
                if (!isValidDate) return false;
                if (a.isRecurring) {
                    const recurrenceStartDate = moment(a.validFrom).startOf('isoWeek');
                    const weeksDifference = currentDate.diff(
                        recurrenceStartDate, 'weeks'
                    );
                    if (weeksDifference >= 0 &&
                        weeksDifference % (a.recurrenceInterval || 1) !== 0
                    ) return false;
                }
                return true;
            });

            const isRoomBusy = existingAssignmentsInRoom.some(existing =>
                isTimeOverlapping(startTime, endTime, existing.startTime, existing.endTime)
            );

            // Stanza occupata in quell'orario: salto
            if (isRoomBusy) continue;

            // 4. Stanza libera: controllo idoneità macchinari
            //    Se non servono macchinari → idonea per definizione
            let isSuitable = true;
            let missingNames = [];

            if (requiredEquipmentIds.size > 0) {
                const roomEquipmentIds = new Set(room.equipmentIds || []);

                requiredEquipmentIds.forEach(equipId => {
                    if (!roomEquipmentIds.has(equipId)) {
                        const eq = allEquipmentList.find(e => e.id === equipId);
                        if (eq) missingNames.push(eq.name);
                    }
                });

                isSuitable = missingNames.length === 0;
            }

            // 5. Aggiungo alla lista (sia idonee che non idonee, così l'utente
            //    può scegliere anche una stanza parzialmente attrezzata se vuole)
            alternativeRooms.push({
                id: room.id,
                name: room.name,
                isSuitable,
                missing: missingNames.join(', ')
            });
        }

        return alternativeRooms;
    };
    
    const isDayClosed = useCallback((day) => {
        if (hd.isHoliday(day.toDate())) {
            return { closed: true, reason: 'Giorno Festivo' };
        }
        const dayStr = day.format('YYYY-MM-DD');
        const dayShifts = monthlyShifts[dayStr];
        if (dayShifts && Object.values(dayShifts).length > 0 && Object.values(dayShifts)[0].name === 'CHIUSO') {
            return { closed: true, reason: 'Struttura Chiusa' };
        }
        return { closed: false, reason: null };
    }, [monthlyShifts]);

    

    const handleToggleRoomClosure = async () => {
    const { room, day } = roomClosureModal;
    const dayStr = day.format('YYYY-MM-DD');
    const monthDocId = day.format('YYYY-MM');
    
    const isCurrentlyClosed = isRoomClosedOnDay(room.id, day);

    const closedRoomsDocRef = doc(db, 'centers', userProfile.centerId, "roomStatus", monthDocId); // <-- MODIFICA QUI
    let updateObject = {};
    let shouldDeleteField = false; // ⭐ NUOVO FLAG: Traccia l'eliminazione per l'aggiornamento locale

    if (isCurrentlyClosed) {
        // --- CASO DI RIAPERTURA (RIMUOVI ID) ---
        const currentIds = closedRooms[dayStr] || [];
        const newIds = currentIds.filter(id => id !== room.id);
        
        // Se l'array diventa vuoto, usiamo deleteField() per rimuovere l'intero campo.
        if (newIds.length === 0) {
            shouldDeleteField = true; // ⭐ IMPOSTA IL FLAG
            updateObject = {
                [dayStr]: deleteField() 
            };
        } else {
            // Se ci sono ancora ID, aggiorniamo l'array con la nuova lista.
            updateObject = {
                [dayStr]: newIds
            };
        }
    } else {
        // --- CASO DI CHIUSURA (AGGIUNGI ID) ---
        // Se si tratta di aggiungere, non usiamo deleteField().
        const currentIds = closedRooms[dayStr] || [];
        if (!currentIds.includes(room.id)) {
            updateObject = {
                [dayStr]: [...currentIds, room.id] // Aggiungi l'ID
            };
        } else {
            // Stanza già chiusa per qualche motivo, non fare nulla.
            setRoomClosureModal({ isOpen: false, room: null, day: null });
            return;
        }
    }

    // Eseguiamo l'aggiornamento con setDoc e merge: true
    await setDoc(closedRoomsDocRef, updateObject, { merge: true });

    // Aggiornamento dello stato locale (Essenziale per la reattività)
    const action = isCurrentlyClosed ? 'riaperto' : 'chiuso';
    await logAction(userProfile, `ha ${action} la stanza "${room.name}" per il giorno ${day.format('DD/MM/YYYY')}`);
    
    // Aggiornamento dello stato locale: usiamo il flag affidabile
    if (shouldDeleteField) { // ⭐ CONTROLLA IL FLAG
        const updatedClosedRooms = { ...closedRooms };
        delete updatedClosedRooms[dayStr];
        setClosedRooms(updatedClosedRooms);
    } else {
        setClosedRooms(prev => ({ ...prev, ...updateObject }));
    }
    
    // ⭐ PASSAGGIO CRUCIALE: Ricarica i dati per garantire consistenza
    // Questo forza l'aggiornamento da Firestore (fonte di verità), 
    // risolvendo l'errore di visualizzazione al refresh.
    await fetchData(); 
    
    setRoomClosureModal({ isOpen: false, room: null, day: null });
};

    useEffect(() => {
        if (isLoading || rooms.length === 0 || Object.keys(businessHours).length === 0 || monthlyAssignments.length === 0) return;

        const monthStart = currentWeek.clone().startOf('month');
        const monthEnd = currentWeek.clone().endOf('month');
        const newSummaryData = {};

        rooms.forEach(room => {
            newSummaryData[room.id] = {
                name: room.name,
                daily: {},
                weekly: { totalMinutes: 0, occupiedMinutes: 0 }, 
                monthly: { totalMinutes: 0, occupiedMinutes: 0 }
            };
        });

        for (let day = monthStart.clone(); day.isSameOrBefore(monthEnd); day.add(1, 'day')) {
            const dayKey = day.isoWeekday();
            const dayHours = businessHours[dayKey];
            
            if (dayHours && !isDayClosed(day).closed) {
                const open = moment(dayHours.open, 'HH:mm');
                const close = moment(dayHours.close, 'HH:mm');
                const totalDayMinutes = close.diff(open, 'minutes');

                rooms.forEach(room => {
                    if (isRoomClosedOnDay(room.id, day)) return;

                    newSummaryData[room.id].monthly.totalMinutes += totalDayMinutes;

                    const assignmentsForDay = monthlyAssignments.filter(a => {
                         if (a.roomId !== room.id || !(a.daysOfWeek || []).includes(dayKey)) return false;
                         if (moment(day).format('YYYY-MM-DD') !== moment(a.validFrom).format('YYYY-MM-DD') && (a.excludedDates || []).includes(day.format('YYYY-MM-DD'))) return false;
                         const isValidDate = moment(day).isBetween(a.validFrom, a.validUntil, 'day', '[]')
                         if (!isValidDate) return false;
                         if (a.isRecurring) {
                            const startDate = moment(a.validFrom).startOf('isoWeek');
                            const weeksDifference = day.diff(startDate, 'weeks');
                            if (weeksDifference > 0 && weeksDifference % a.recurrenceInterval !== 0) return false;
                         }
                         return true;
                    });
                    
                    const occupiedMinutes = assignmentsForDay.reduce((acc, curr) => {
                        return acc + moment(curr.endTime, 'HH:mm').diff(moment(curr.startTime, 'HH:mm'), 'minutes');
                    }, 0);
                    newSummaryData[room.id].monthly.occupiedMinutes += occupiedMinutes;
                });
            }
        }

        const weekStart = currentWeek.clone().startOf('isoWeek');
        for (let i = 0; i < 6; i++) {
            const day = weekStart.clone().add(i, 'days');
            const dayKey = day.isoWeekday();
            const dayStr = day.format('YYYY-MM-DD');
            const dayHours = businessHours[dayKey];

            rooms.forEach(room => {
                if (dayHours && !isDayClosed(day).closed && !isRoomClosedOnDay(room.id, day)) {
                    const open = moment(dayHours.open, 'HH:mm');
                    const close = moment(dayHours.close, 'HH:mm');
                    const totalMinutes = close.diff(open, 'minutes');
                    
                    newSummaryData[room.id].weekly.totalMinutes += totalMinutes;

                     const assignmentsForDay = assignments.filter(a => {
                         if (a.roomId !== room.id || !(a.daysOfWeek || []).includes(dayKey)) return false;
                         if ((a.excludedDates || []).includes(day.format('YYYY-MM-DD'))) return false;
                         const isValidDate = moment(day).isBetween(a.validFrom, a.validUntil, 'day', '[]')
                         if (!isValidDate) return false;
                         if (a.isRecurring) {
                            const startDate = moment(a.validFrom).startOf('isoWeek');
                            const weeksDifference = day.diff(startDate, 'weeks');
                            if (weeksDifference > 0 && weeksDifference % a.recurrenceInterval !== 0) return false;
                         }
                         return true;
                    });

                    const occupiedMinutes = assignmentsForDay.reduce((acc, curr) => {
                        return acc + moment(curr.endTime, 'HH:mm').diff(moment(curr.startTime, 'HH:mm'), 'minutes');
                    }, 0);
                    
                    newSummaryData[room.id].weekly.occupiedMinutes += occupiedMinutes;

                    newSummaryData[room.id].daily[dayStr] = {
                        occupiedHours: (occupiedMinutes / 60).toFixed(1),
                        freeHours: ((totalMinutes - occupiedMinutes) / 60).toFixed(1)
                    };
                } else {
                     newSummaryData[room.id].daily[dayStr] = { occupiedHours: 'N/D', freeHours: 'N/D' };
                }
            });
        }
        setSummaryData(newSummaryData);

    }, [isLoading, rooms, assignments, monthlyAssignments, businessHours, currentWeek, monthlyShifts, closedRooms, isDayClosed, isRoomClosedOnDay]);


    const filteredAssignments = assignments.filter(assignment => {
        const doctorMatch = !filteredDoctor || assignment.doctorId === filteredDoctor.value;
        const specialtyMatch = !filteredSpecialty || (assignment.doctorSpecialties && assignment.doctorSpecialties.some(s => s.id === filteredSpecialty.value));
        return doctorMatch && specialtyMatch;
    });

    const doctorOptions = Array.isArray(doctors) ? doctors.map(d => ({ value: d.id, label: `${d.firstName} ${d.lastName}` })) : [];
    const specialtyOptions = Array.isArray(specialties) ? specialties.map(s => ({ value: s.id, label: s.name })) : [];
    
    const handleSaveAssignment = async (data, bypassOverlapCheck = false) => {
        console.log("Saving assignment data:", data, "Bypass:", bypassOverlapCheck);

        // --- CONTROLLO SOVRAPPOSIZIONE GIORNO PER GIORNO ---
        if (!bypassOverlapCheck) {
            const instancesToCheck = generateRecurrenceDates(data);
            let firstConflict = null;

            // Ciclo su tutte le date previste per questo inserimento
            for (const dateInstance of instancesToCheck) {
                const dateStr = dateInstance.format('YYYY-MM-DD');
                
                // Cerca un conflitto in questa specifica data
                const conflictingAssignment = assignments.find(existing => {
                    if (data.id && existing.id === data.id) return false; // Ignora se stesso
                    if (existing.roomId !== data.roomId) return false;    // Solo stessa stanza

                    // Verifica se l'assegnazione esistente "cade" in questo giorno
                    const existingStart = moment(existing.validFrom);
                    const existingEnd = moment(existing.validUntil);
                    if (!dateInstance.isBetween(existingStart, existingEnd, 'day', '[]')) return false;
                    
                    if (!(existing.daysOfWeek || []).includes(dateInstance.isoWeekday())) return false;
                    if ((existing.excludedDates || []).includes(dateStr)) return false;
                    
                    if (existing.isRecurring) {
                        const recStart = existingStart.clone().startOf('isoWeek');
                        const weeksDiff = dateInstance.clone().startOf('isoWeek').diff(recStart, 'weeks');
                        if (weeksDiff % (existing.recurrenceInterval || 1) !== 0) return false;
                    }

                    // Se il giorno coincide, controlla l'orario
                    return isTimeOverlapping(data.startTime, data.endTime, existing.startTime, existing.endTime);
                });

                if (conflictingAssignment) {
                    firstConflict = { date: dateInstance, conflict: conflictingAssignment };
                    break; // Esci al primo conflitto trovato
                }
            }

            if (firstConflict) {
                // Trovato conflitto!
                const conflictingDoc = doctors.find(d => d.id === firstConflict.conflict.doctorId);
                const conflictingDocName = conflictingDoc ? `${conflictingDoc.firstName} ${conflictingDoc.lastName}` : 'Sconosciuto';
                const conflictDateStr = firstConflict.date.format('DD/MM/YYYY');
                const targetRoomName = rooms.find(r => r.id === data.roomId)?.name || 'Stanza';

                // Messaggio personalizzato
                const warningMsg = `Attenzione: in data ${conflictDateStr} la stanza "${targetRoomName}" è già occupata dal Dott. ${conflictingDocName}.`;

                // Cerca alternative per quel giorno specifico
                // Passo anche le prestazioni del turno per il controllo macchinari
                const alternatives = findAlternativeRooms(
                    data.doctorId, firstConflict.date, data.startTime, data.endTime,
                    data.roomId, assignments, rooms, doctors, specialties, allEquipment,
                    data.allowedServices || [], services
                );

                setOverlapModalState({
                    isOpen: true,
                    conflictData: {
                        assignmentData: { ...data, doctorName: data.doctorName },
                        alternatives: alternatives,
                        isSwap: false,
                        targetRoomName: targetRoomName,
                        customWarning: warningMsg,
                        conflictDate: firstConflict.date.format('YYYY-MM-DD') // Salviamo la data per l'eccezione
                    }
                });

                setIsModalOpen(false); // Chiudi il form di inserimento
                return; // Stop salvataggio
            }
        }
        // --- FINE CONTROLLO ---

        // Se non ci sono conflitti (o bypass è true), procedi al salvataggio standard
        const assignmentDataToSave = {
            roomId: data.roomId,
            doctorId: data.doctorId,
            isFreeRoom: data.isFreeRoom || false, // 🎯 FIX: Salva il flag Stanza Libera!
            startTime: data.startTime,
            endTime: data.endTime,
            daysOfWeek: data.daysOfWeek,
            validFrom: data.validFrom,
            validUntil: data.validUntil,
            isRecurring: data.isRecurring || false,
            recurrenceInterval: data.isRecurring ? Number(data.recurrenceInterval || 1) : 1,
            excludedDates: data.excludedDates || [],
            collaboratorIds: data.collaboratorIds || [],
            centerId: userProfile.centerId,
            allowedServices: data.allowedServices || [],
        };

        try {
            if (data.id) { // Modifica
                 await updateDoc(doc(db, 'centers', userProfile.centerId, "roomAssignments", data.id), assignmentDataToSave);
                 await logAction(userProfile, `ha modificato assegnazione per ${data.doctorId}`);
            } else { // Creazione
                 await addDoc(collection(db, 'centers', userProfile.centerId, "roomAssignments"), assignmentDataToSave);
                 await logAction(userProfile, `ha creato assegnazione per ${data.doctorId}`);
            }
            
            fetchData();
            if (!choiceModal.isOpen && !overlapModalState.isOpen) {
                 toast.success("Assegnazione salvata con successo!");
            }
        } catch (error) {
             console.error("Errore salvataggio:", error);
             toast.error("Errore durante il salvataggio.");
        } finally {
            if (!choiceModal.isOpen) setIsModalOpen(false); 
        }
    };

    const handleDateChange = (date) => {
        const selectedMoment = moment(date);
        setCurrentWeek(selectedMoment.clone().startOf('isoWeek'));
        setScrollToDate(selectedMoment);
    };

    useEffect(() => {
        if (scrollToDate && scrollToDate.isSame(currentWeek, 'isoWeek')) {
            const dayIndex = scrollToDate.isoWeekday() - 1;
            openSingleAccordion(dayIndex);
            setTimeout(() => {
                const dayId = `day-accordion-${scrollToDate.format('YYYY-MM-DD')}`;
                const element = document.getElementById(dayId);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }, 150);
            setScrollToDate(null);
        }
    }, [currentWeek, scrollToDate, openSingleAccordion]);

    // Calcola i macchinari richiesti dalle prestazioni (allowedServices)
    // dell'assegnazione sorgente. Stessa logica del controllo in AssignmentModal.
    // Restituisce un array di oggetti {id, name} dei macchinari necessari.
    const getSwapRequiredEquipment = (assignment) => {
        if (!assignment?.allowedServices?.length) return [];

        const required = [];
        const seenIds = new Set();

        assignment.allowedServices.forEach(serviceId => {
            const service = services.find(s => s.id === serviceId);
            if (!service?.requiredEquipmentId) return;

            const equipment = allEquipment.find(
                e => e.id === service.requiredEquipmentId
            );
            if (equipment && !seenIds.has(equipment.id)) {
                seenIds.add(equipment.id);
                required.push({ id: equipment.id, name: equipment.name });
            }
        });

        return required;
    };

    // Controlla se una stanza ha tutti i macchinari richiesti.
    // Restituisce {suitable: bool, missing: [{id, name}]}
    const checkRoomEquipmentSuitability = (room, requiredEquipment) => {
        if (!requiredEquipment.length) return { suitable: true, missing: [] };

        const roomEquipIds = new Set(room.equipmentIds || []);
        const missing = requiredEquipment.filter(eq => !roomEquipIds.has(eq.id));
        return { suitable: missing.length === 0, missing };
    };

    const initiateSwap = (assignment, day) => setSwapState({ active: true, sourceAssignment: assignment, sourceDay: day });
    const cancelSwap = () => setSwapState({ active: false, sourceAssignment: null, sourceDay: null });

    // 🆕 Copia/Incolla Prestazioni
    const initiateCopyServices = (assignment) => setCopyServicesState({ active: true, sourceAssignment: assignment });
    const cancelCopyServices = () => setCopyServicesState({ active: false, sourceAssignment: null });

        // Target = slot GIÀ OCCUPATO: non copiamo subito, chiediamo prima
    // Sostituisci/Aggiungi tramite il piccolo modale di conferma.
    const handlePasteOnAssignment = (targetAssignment) => {
        setPasteServicesConfirm({ isOpen: true, targetAssignment });
    };

    // Esegue davvero la copia sull'assegnazione target, in base alla scelta.
    const executePasteServices = async (mode) => { // 'replace' | 'merge'
        const { targetAssignment } = pasteServicesConfirm;
        const sourceServices = copyServicesState.sourceAssignment?.allowedServices || [];
        if (!targetAssignment) return;

        const finalServices = mode === 'replace'
            ? [...sourceServices]
            : [...new Set([...(targetAssignment.allowedServices || []), ...sourceServices])];

        try {
            await updateDoc(doc(db, 'centers', userProfile.centerId, "roomAssignments", targetAssignment.id), {
                allowedServices: finalServices,
            });
            await logAction(userProfile, `ha copiato le prestazioni sull'assegnazione di ${targetAssignment.doctorName || 'stanza libera'}`);
            toast.success(mode === 'replace' ? "Prestazioni sostituite!" : "Prestazioni aggiunte!");
            fetchData();
        } catch (error) {
            console.error("Errore copia prestazioni:", error);
            toast.error("Errore durante la copia delle prestazioni.");
        } finally {
            setPasteServicesConfirm({ isOpen: false, targetAssignment: null });
            cancelCopyServices();
        }
    };

    const handleTargetSlotClick = (target) => {
    const { sourceAssignment } = swapState;

    // --- CONTROLLO MACCHINARI SULLA STANZA TARGET ---
    // Determina la stanza di destinazione (slot libero o card occupata)
    const targetRoom = target.type === 'free'
        ? target.room
        : rooms.find(r => r.id === target.assignment?.roomId);

    if (targetRoom) {
        // Calcola i macchinari richiesti dall'assegnazione sorgente
        const requiredEquipment = getSwapRequiredEquipment(sourceAssignment);
        const { suitable, missing } = checkRoomEquipmentSuitability(
            targetRoom, requiredEquipment
        );

        // Se mancano macchinari, apri il modale di avviso
        // e sospendi il flusso swap fino alla scelta dell'utente
        if (!suitable) {
            setSwapEquipmentWarning({
                isOpen: true,
                missingEquipment: missing,
                pendingTarget: target
            });
            return; // Blocco qui: l'utente deve scegliere dal modale
        }
    }
    // -----------------------------------------------

    // Nessun problema di macchinari: proseguo con il flusso normale
    const isEffectivelyRecurring = sourceAssignment.isRecurring ||
        moment(sourceAssignment.validUntil).isAfter(
            moment(sourceAssignment.validFrom), 'day'
        );

    if (isEffectivelyRecurring) {
        setChoiceModal({
            isOpen: true, action: 'swap',
            data: { source: swapState, target }
        });
    } else {
        handleChoice('this_day_only', target);
    }
};

    // Callback del modale avviso macchinari: l'utente forza lo swap
    // nonostante i macchinari mancanti
    const handleForceSwapDespiteEquipment = () => {
        const target = swapEquipmentWarning.pendingTarget;
        setSwapEquipmentWarning({ isOpen: false, missingEquipment: [], pendingTarget: null });

        if (!target) return;

        // Riprendo il flusso normale, ignorando il controllo macchinari
        const { sourceAssignment } = swapState;
        const isEffectivelyRecurring = sourceAssignment.isRecurring ||
            moment(sourceAssignment.validUntil).isAfter(
                moment(sourceAssignment.validFrom), 'day'
            );

        if (isEffectivelyRecurring) {
            setChoiceModal({
                isOpen: true, action: 'swap',
                data: { source: swapState, target }
            });
        } else {
            handleChoice('this_day_only', target);
        }
    };
    

    const handleChoice = async (choice, directTarget = null, bypassOverlapCheck = false) => {
        let action, data;

        // Determina l'azione e i dati
        if (choiceModal.isOpen) {
             action = choiceModal.action;
             data = choiceModal.data;
         } else if (swapState.active && directTarget){ // Assicurati che lo swap sia attivo per il caso 'else'
             action = 'swap';
             data = { source: swapState, target: directTarget };
         } else {
             console.error("handleChoice chiamato in uno stato non valido.");
             cancelSwap();
             setChoiceModal({ isOpen: false, data: null, action: null });
             return;
         }


        const batch = writeBatch(db);
        let overlapError = false; // Flag per bloccare commit

        if (action === 'edit') {
            const { day, newData, originalData } = data;

            if (choice === 'this_day_only') {
                const modificationDate = day.format('YYYY-MM-DD');
                batch.update(doc(db, 'centers', userProfile.centerId, "roomAssignments", originalData.id), { excludedDates: [...(originalData.excludedDates || []), modificationDate] }); // <-- MODIFICA QUI
                const singleEventData = { ...newData, isRecurring: false, validFrom: modificationDate, validUntil: modificationDate, daysOfWeek: [day.isoWeekday()] };
                delete singleEventData.id;
                batch.set(doc(collection(db, 'centers', userProfile.centerId, "roomAssignments")), singleEventData); // <-- MODIFICA QUI

            } else if (choice === 'all_future') {
                // 1. Usa la NUOVA data di inizio dal form (newData)
                const newStartDate = newData.validFrom;
                const dayBeforeNewStart = moment(newStartDate).subtract(1, 'day').format('YYYY-MM-DD');

                // 2. Tronca la VECCHIA serie di appuntamenti basandoti sulla NUOVA data di inizio
                if (moment(dayBeforeNewStart).isSameOrAfter(originalData.validFrom)) {
                    batch.update(doc(db, 'centers', userProfile.centerId, "roomAssignments", originalData.id), { validUntil: dayBeforeNewStart }); // <-- MODIFICA QUI
                } else {
                    // Se la nuova data di inizio è precedente a quella vecchia, elimina la vecchia serie
                    batch.delete(doc(db, 'centers', userProfile.centerId, "roomAssignments", originalData.id)); // <-- MODIFICA QUI
                }

                // 3. Crea la NUOVA serie di appuntamenti, assicurandoti che usi la sua 'validFrom'
                const newRecurringData = { ...newData }; // newData contiene già la validFrom corretta
                delete newRecurringData.id;
                batch.set(doc(collection(db, 'centers', userProfile.centerId, "roomAssignments")), newRecurringData); // <-- MODIFICA QUI
            }

        } else if (action === 'delete') {
            const { assignment, day } = data;
            const deleteDate = day.format('YYYY-MM-DD');
            if (choice === 'this_day_only') {
                batch.update(doc(db, 'centers', userProfile.centerId, "roomAssignments", assignment.id), { excludedDates: [...(assignment.excludedDates || []), deleteDate] }); // <-- MODIFICA QUI
            } else if (choice === 'all_future') {
                const dayBefore = day.clone().subtract(1, 'day').format('YYYY-MM-DD');
                if (moment(dayBefore).isSameOrAfter(assignment.validFrom)) {
                    batch.update(doc(db, 'centers', userProfile.centerId, "roomAssignments", assignment.id), { validUntil: dayBefore }); // <-- MODIFICA QUI
                } else {
                    batch.delete(doc(db, 'centers', userProfile.centerId, "roomAssignments", assignment.id)); // <-- MODIFICA QUI
                }
            }

        // --- INIZIO BLOCCO SWAP CON CONTROLLO SOVRAPPOSIZIONE ---
        } else if (action === 'swap') {
            const { source, target } = data;

            // Controllo di sicurezza: se il target è ancora nullo, interrompiamo l'operazione
            if (!target) {
                console.error("Errore: il target per lo scambio è nullo.");
                cancelSwap();
                return;
            }

            const { sourceAssignment, sourceDay } = source;
            //const sourceDateStr = sourceDay.format('YYYY-MM-DD');


            // --- Funzione interna per controllare sovrapposizione ---
                const checkMoveOverlap = (assignmentToMove, targetRoomId, targetDayMoment, excludeAssignmentId = null, bypassCheck) => {
                // Se bypassCheck è true (dal modale di conflitto), salta il controllo
                if (bypassCheck) return false;

                const targetDayStr = targetDayMoment.format('YYYY-MM-DD');
                const targetDayOfWeek = targetDayMoment.isoWeekday();

                const existingAssignments = assignments.filter(a => {
                    if (excludeAssignmentId && a.id === excludeAssignmentId) return false;
                    const idToExcludeForSelfCheck = assignmentToMove?.id;
                    if (!idToExcludeForSelfCheck) return true;
                    if (targetRoomId === assignmentToMove.roomId && targetDayStr === moment(assignmentToMove.validFrom).format('YYYY-MM-DD') && a.id === idToExcludeForSelfCheck) {
                        return false;
                    }
                    if (a.roomId !== targetRoomId) return false;
                    const dayToCheckMoment = moment(targetDayStr);
                    if (!(a.daysOfWeek || []).includes(targetDayOfWeek)) return false;
                    if ((a.excludedDates || []).includes(targetDayStr)) return false;
                    const isValidDate = dayToCheckMoment.isBetween(a.validFrom, a.validUntil, 'day', '[]');
                    if (!isValidDate) return false;
                    if (a.isRecurring) {
                        const recurrenceStartDate = moment(a.validFrom).startOf('isoWeek');
                        const weeksDifference = dayToCheckMoment.diff(recurrenceStartDate, 'weeks');
                        if (weeksDifference >= 0 && weeksDifference % (a.recurrenceInterval || 1) !== 0) return false;
                    }
                    return true;
                });

                const overlap = existingAssignments.some(existing =>
                    isTimeOverlapping(
                        assignmentToMove.startTime, assignmentToMove.endTime,
                        existing.startTime, existing.endTime
                    )
                );

                if (overlap) {
                    // --- CHIAMATA MODIFICATA: Passa i dati extra a findAlternativeRooms ---
                    const alternatives = findAlternativeRooms(
                        assignmentToMove.doctorId, // Passa doctorId
                        targetDayMoment, assignmentToMove.startTime, assignmentToMove.endTime,
                        targetRoomId, assignments, rooms,
                        doctors, specialties, allEquipment // Passa i dati
                    );
                    
                    setOverlapModalState({
                        isOpen: true,
                        conflictData: {
                            assignmentData: assignmentToMove,
                            alternatives: alternatives,
                            isSwap: true,
                            targetRoomName: rooms.find(r => r.id === targetRoomId)?.name || targetRoomId
                        }
                    });
                    setChoiceModal({ isOpen: false, data: null, action: null });
                    cancelSwap();
                    overlapError = true;
                }
                return overlap;
            };
            // --- FINE checkMoveOverlap MODIFICATO ---

            // Esegui controlli solo se non bypassato
            if (!bypassOverlapCheck) {
                 const targetRoomId = (target.type === 'free') ? target.room?.id : target.assignment?.roomId; // Aggiunto controllo esistenza room/assignment
                 if(!targetRoomId){
                     console.error("Target room ID non trovato per lo swap");
                     overlapError = true; // Segnala errore se non troviamo la stanza target
                 } else {
                     console.log(`[Swap Check 1] Source (${sourceAssignment.id}) -> Room ${targetRoomId}`);
                     if (checkMoveOverlap(sourceAssignment, targetRoomId, sourceDay, target.type === 'busy' ? target.assignment?.id : null, bypassOverlapCheck)) {
                        overlapError = true;
                        }

                    // Check 2
                    if (!overlapError && target.type === 'busy' && target.assignment) {
                    const targetAssignment = target.assignment;
                    if (checkMoveOverlap(targetAssignment, sourceAssignment.roomId, sourceDay, sourceAssignment.id, bypassOverlapCheck)) {
                    overlapError = true;
                        }
                    }
                 }

            }

            // Se non ci sono errori (o se il controllo è bypassato), aggiungi al batch
            if (!overlapError) {
                console.log(bypassOverlapCheck ? "[Swap OK - Bypass]" : "[Swap OK]", "Preparo batch...");
                 if (target.type === 'free' && target.room) { // Aggiunto controllo target.room
                 const newRoomId = target.room.id;
                 if (choice === 'this_day_only') {
                     batch.update(doc(db, 'centers', userProfile.centerId, "roomAssignments", sourceAssignment.id), { excludedDates: [...(sourceAssignment.excludedDates || []), sourceDay.format('YYYY-MM-DD')] }); // <-- MODIFICA QUI
                     const newSingleData = { ...sourceAssignment, roomId: newRoomId, isRecurring: false, validFrom: sourceDay.format('YYYY-MM-DD'), validUntil: sourceDay.format('YYYY-MM-DD'), daysOfWeek: [sourceDay.isoWeekday()] };
                     delete newSingleData.id;
                     batch.set(doc(collection(db, 'centers', userProfile.centerId, "roomAssignments")), newSingleData); // <-- MODIFICA QUI
                } else if (choice === 'all_future') {
                    const dayBefore = sourceDay.clone().subtract(1, 'day').format('YYYY-MM-DD');
                    if(moment(dayBefore).isSameOrAfter(sourceAssignment.validFrom)) {
                        batch.update(doc(db, 'centers', userProfile.centerId, "roomAssignments", sourceAssignment.id), { validUntil: dayBefore }); // <-- MODIFICA QUI
                    } else {
                        batch.delete(doc(db, 'centers', userProfile.centerId, "roomAssignments", sourceAssignment.id)); // <-- MODIFICA QUI
                    }
                    const newSeriesData = { ...sourceAssignment, roomId: newRoomId, validFrom: sourceDay.format('YYYY-MM-DD') };
                    delete newSeriesData.id;
                    batch.set(doc(collection(db, 'centers', userProfile.centerId, "roomAssignments")), newSeriesData); // <-- MODIFICA QUI
                }
            } else if (target.type === 'busy' && target.assignment) { // SCAMBIO con altro appuntamento
                const targetAssignment = target.assignment;
                if (choice !== 'this_day_only') {
                    alert("Lo scambio tra due appuntamenti ricorrenti può essere eseguito solo per la singola data. L'operazione verrà eseguita solo per oggi.");
                }

                const sourceDateStr = sourceDay.format('YYYY-MM-DD');
                batch.update(doc(db, 'centers', userProfile.centerId, "roomAssignments", sourceAssignment.id), { excludedDates: [...(sourceAssignment.excludedDates || []), sourceDateStr] }); // <-- MODIFICA QUI
                batch.update(doc(db, 'centers', userProfile.centerId, "roomAssignments", targetAssignment.id), { excludedDates: [...(targetAssignment.excludedDates || []), sourceDateStr] }); // <-- MODIFICA QUI

                const newSourceData = { ...sourceAssignment, roomId: targetAssignment.roomId, isRecurring: false, validFrom: sourceDateStr, validUntil: sourceDateStr, daysOfWeek: [sourceDay.isoWeekday()] };
                delete newSourceData.id;
                batch.set(doc(collection(db, 'centers', userProfile.centerId, "roomAssignments")), newSourceData); // <-- MODIFICA QUI

                const newTargetData = { ...targetAssignment, roomId: sourceAssignment.roomId, isRecurring: false, validFrom: sourceDateStr, validUntil: sourceDateStr, daysOfWeek: [sourceDay.isoWeekday()] };
                delete newTargetData.id;
                batch.set(doc(collection(db, 'centers', userProfile.centerId, "roomAssignments")), newTargetData); // <-- MODIFICA QUI
            } else if (!target.room && !target.assignment) {
                  console.error("Dati target mancanti per l'operazione di swap.");
                  // Potresti voler mostrare un errore all'utente qui
                  overlapError = true; // Impedisci il commit se i dati target sono invalidi
             }
                
            } else {
                 console.log("[Swap BLOCKED] Sovrapposizione rilevata.");
                 // Non fare return qui, lascia che il codice arrivi al cleanup
            }
        }
        // --- FINE BLOCCO SWAP MODIFICATO ---

        // Esegui il commit SOLO se non ci sono stati errori di sovrapposizione
        if (!overlapError) {
            try {
                await batch.commit();

                // Logica di Log
                let logMessage = "ha ";
                const doctorName = action === 'edit' ? doctors.find(d=>d.id === data.newData.doctorId)?.name :
                                 action === 'delete' ? data.assignment.doctorName :
                                 action === 'swap' ? data.source.sourceAssignment.doctorName : 'N/D';
                const dateFormatted = action !== 'edit' && action !== 'delete' && action !== 'swap' ? '' :
                                      (action === 'edit' || action === 'delete') ? moment(data.day).format('DD/MM') : moment(data.source.sourceDay).format('DD/MM');

                if (action === 'edit') logMessage += `modificato assegnazione per ${doctorName} il ${dateFormatted}`;
                else if (action === 'delete') logMessage += `cancellato assegnazione per ${doctorName} il ${dateFormatted}`;
                else if (action === 'swap') logMessage += `scambiato/spostato assegnazione per ${doctorName} il ${dateFormatted}`;

                if (choice === 'this_day_only') logMessage += " (solo questa data)";
                else if (choice === 'all_future') logMessage += " (questa e future)";

                await logAction(userProfile, logMessage);
                toast.success("Operazione completata!");

                fetchData(); // Ricarica dati DOPO commit OK
            } catch (error) {
                 console.error("Errore durante il commit del batch:", error);
                 toast.error("Si è verificato un errore durante l'applicazione delle modifiche.");
            }
        }
       
        setChoiceModal({ isOpen: false, data: null, action: null });
        cancelSwap();
     };

     const handleSelectAlternative = async (alternativeRoomId) => {
         const { assignmentData, isSwap, conflictDate } = overlapModalState.conflictData;
         setOverlapModalState({ isOpen: false, conflictData: null });

         // 1. GESTIONE "INSERISCI LO STESSO" (Forzatura)
         // Se l'ID stanza scelto è uguale a quello originale, l'utente ha cliccato "Inserisci lo stesso"
         if (alternativeRoomId === assignmentData.roomId) {
             if (isSwap) {
                 // Se era uno swap forzato, usiamo la tua logica swap esistente
                 // ma senza cambiare la stanza target (simulatedTarget userà la stanza originale se occupata)
                 // Nota: nel caso swap, questo ramo è raro perché di solito si annulla, ma per sicurezza:
                 const sourceAssignmentOriginal = swapState.sourceAssignment || assignmentData;
                 const sourceDayOriginal = swapState.sourceDay || moment(assignmentData.validFrom);
                 
                 // Target è la stanza occupata originale
                 const simulatedTarget = {
                     type: 'free', // Trattalo come free per forzare l'inserimento
                     room: rooms.find(r => r.id === alternativeRoomId), 
                     day: sourceDayOriginal, 
                     startTime: sourceAssignmentOriginal.startTime,
                     endTime: sourceAssignmentOriginal.endTime,
                 };
                 const tempSwapState = { active: true, sourceAssignment: sourceAssignmentOriginal, sourceDay: sourceDayOriginal };
                 setSwapState(tempSwapState); 
                 setTimeout(() => {
                     handleChoice('this_day_only', simulatedTarget, true); // true = BYPASS check
                 }, 0);
             } else {
                 // Inserimento/Modifica forzato: salva normalmente bypassando il controllo
                 handleSaveAssignment(assignmentData, true); 
             }
             return;
         }

         // 2. GESTIONE CAMBIO STANZA (Alternativa selezionata)
         
         // === TUA LOGICA SWAP ORIGINALE (MANTENUTA INTATTA) ===
         if (isSwap) {
             const sourceAssignmentOriginal = swapState.sourceAssignment || assignmentData;
             const sourceDayOriginal = swapState.sourceDay || moment(assignmentData.validFrom); 

             const simulatedTarget = {
                 type: 'free',
                 room: rooms.find(r => r.id === alternativeRoomId),
                 day: sourceDayOriginal, 
                 startTime: sourceAssignmentOriginal.startTime,
                 endTime: sourceAssignmentOriginal.endTime,
             };

             const tempSwapState = { active: true, sourceAssignment: sourceAssignmentOriginal, sourceDay: sourceDayOriginal };
             setSwapState(tempSwapState); 

             setTimeout(() => {
                 handleChoice(
                     'this_day_only', // Forza 'solo questo giorno' quando si sceglie da modale conflitto
                     simulatedTarget,
                     true // BYPASS overlap check
                 );
             }, 0);
         } 
         // === FINE TUA LOGICA SWAP ===
         
         else {
             // === NUOVA LOGICA "SPLIT" PER INSERIMENTO/MODIFICA ===
             // Invece di cambiare tutto (updatedAssignmentData), creiamo un'eccezione
             
             const batch = writeBatch(db);
             const centerId = userProfile.centerId;

             try {
                 // A. PREPARA ASSEGNAZIONE PRINCIPALE 
                 // (Mantiene stanza originale, ma ESCLUDE la data del conflitto)
                 const mainAssignmentData = { 
                     ...assignmentData, 
                     excludedDates: [...(assignmentData.excludedDates || []), conflictDate] 
                 };
                 // Pulizia campi non DB
                 delete mainAssignmentData.id; 
                 delete mainAssignmentData.doctorName; 
                 delete mainAssignmentData.roomName;

                 // B. PREPARA ASSEGNAZIONE ECCEZIONE 
                 // (Nuova stanza, SOLO per la data del conflitto)
                 const exceptionData = {
                     ...assignmentData, // Copia tutto
                     id: null, // Nuovo ID
                     roomId: alternativeRoomId, // <--- CAMBIA STANZA QUI
                     validFrom: conflictDate,   // <--- SOLO QUESTA DATA
                     validUntil: conflictDate,
                     daysOfWeek: [moment(conflictDate).isoWeekday()],
                     isRecurring: false,
                     recurrenceInterval: 1,
                     excludedDates: []
                 };
                 delete exceptionData.id;
                 delete exceptionData.doctorName;
                 delete exceptionData.roomName;

                 // ESECUZIONE BATCH
                 if (assignmentData.id) {
                     // Caso Modifica: Aggiorna l'esistente (aggiungendo l'esclusione)
                     const mainRef = doc(db, 'centers', centerId, "roomAssignments", assignmentData.id);
                     batch.update(mainRef, { excludedDates: mainAssignmentData.excludedDates });
                 } else {
                     // Caso Nuovo: Crea il principale
                     const newMainRef = doc(collection(db, 'centers', centerId, "roomAssignments"));
                     batch.set(newMainRef, { ...mainAssignmentData, centerId });
                 }

                 // Crea SEMPRE l'eccezione come nuovo documento
                 const exceptionRef = doc(collection(db, 'centers', centerId, "roomAssignments"));
                 batch.set(exceptionRef, { ...exceptionData, centerId });

                 await batch.commit();
                 
                 await logAction(userProfile, `ha creato assegnazione con eccezione (cambio stanza) il ${moment(conflictDate).format('DD/MM')}`);
                 toast.success("Salvato! La stanza è stata cambiata solo per la data del conflitto.");
                 fetchData(); // Ricarica il calendario

             } catch (error) {
                 console.error("Errore salvataggio eccezione:", error);
                 toast.error("Errore durante il salvataggio con eccezione.");
             }
         }
     };

        const handleDeleteAssignment = async (assignment, day) => {
        const isEffectivelyRecurring = assignment.isRecurring || moment(assignment.validUntil).isAfter(moment(assignment.validFrom), 'day');

        if (isEffectivelyRecurring) {
            // Se si ripete, apri il modale di scelta unificato
            setChoiceModal({ 
                isOpen: true, 
                action: 'delete',
                data: { assignment, day } 
            });
        } else {
            // Altrimenti, cancella direttamente
            if (window.confirm("Sei sicuro di voler eliminare questa assegnazione?")) {
                await deleteDoc(doc(db, 'centers', userProfile.centerId, "roomAssignments", assignment.id)); // <-- MODIFICA QUI
                fetchData();
            }
        }
    };

    const openModal = (day, assignment = null, freeSlot = null, preselectedRoomId = null) => {
    // Se stiamo creando un nuovo appuntamento, calcoliamo le date di default
    const defaults = {};
    if (!assignment) {
        defaults.defaultValidFrom = day.toDate(); // Il giorno selezionato
        defaults.defaultValidTo = day.clone().add(12, 'months').toDate(); // 12 mesi dopo
    }

    setModalData({
        day, 
        assignment, 
        preselectedRoomId,
        preselectedStartTime: freeSlot ? freeSlot.startTime : null,
        preselectedEndTime: freeSlot ? freeSlot.endTime : null,
        ...defaults // Aggiungiamo le date di default a modalData
    });
    setIsModalOpen(true);
};

    const changeWeek = (amount) => setCurrentWeek(prev => prev.clone().add(amount, 'weeks'));
    const daysOfWeek = Array.from({ length: 6 }, (_, i) => currentWeek.clone().add(i, 'days'));

    const handleMouseEnterRoom = (e, room) => {
        const content = room.equipmentNames.length > 0 ? room.equipmentNames.join('\n') : 'Nessun macchinario';
        setTooltip({ visible: true, content: content, x: e.clientX, y: e.clientY });
    };
    const handleMouseLeaveRoom = () => {
        setTooltip({ ...tooltip, visible: false });
    };
    
    const handleMouseEnterCollaborator = (e, collaboratorIds) => {
        const collaboratorShortNames = (collaboratorIds || [])
            .map(id => {
                const collabDoctor = doctors.find(d => d.id === id);
                return collabDoctor ? `${collabDoctor.firstName.charAt(0)}. ${collabDoctor.lastName}` : null;
            })
            .filter(Boolean);

        const tooltipContent = collaboratorShortNames.map(name => `🔵 ${name}`).join('\n');
        setTooltip({
            visible: true,
            content: tooltipContent || 'Nessun collaboratore',
            x: e.clientX,
            y: e.clientY
        });
    };
    const isFilterActive = filteredDoctor || filteredSpecialty;

    const weeklyFilteredOccurrences = [];
    if (isFilterActive) {
        daysOfWeek.forEach(day => {
            if (isDayClosed(day).closed) return;

            const dayKey = day.isoWeekday();
            const assignmentsForDay = filteredAssignments.filter(a => {
                if (!(a.daysOfWeek || []).includes(dayKey)) return false;
                if ((a.excludedDates || []).includes(day.format('YYYY-MM-DD'))) return false;
                const isValidDate = moment(day).isBetween(a.validFrom, a.validUntil, 'day', '[]')
                if (!isValidDate) return false;
                if (a.isRecurring) {
                    const startDate = moment(a.validFrom).startOf('isoWeek');
                    const weeksDifference = day.diff(startDate, 'weeks');
                    if (weeksDifference > 0 && weeksDifference % a.recurrenceInterval !== 0) return false;
                }
                return true;
            });
            assignmentsForDay.forEach(assignment => {
                weeklyFilteredOccurrences.push({
                    actualDate: day,
                    assignment: assignment
                });
            });
        });
        weeklyFilteredOccurrences.sort((a,b) => a.actualDate.unix() - b.actualDate.unix() || a.assignment.startTime.localeCompare(b.assignment.startTime));
    }
    
    return (
    <>
    <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
        />
        <OverlapSuggestionModal
                isOpen={overlapModalState.isOpen}
                onClose={() => setOverlapModalState({ isOpen: false, conflictData: null })}
                conflictData={overlapModalState.conflictData}
                onSelectAlternative={handleSelectAlternative}
                rooms={rooms}  
                doctors={doctors}
            />
        {roomClosureModal.isOpen && (
            <ConfirmationModal
                title={isRoomClosedOnDay(roomClosureModal.room.id, roomClosureModal.day) ? "Conferma Riapertura" : "Conferma Chiusura"}
                onConfirm={handleToggleRoomClosure}
                onClose={() => setRoomClosureModal({ isOpen: false, room: null, day: null })}
            >
                <p>
                    {isRoomClosedOnDay(roomClosureModal.room.id, roomClosureModal.day) 
                        ? `Sei sicuro di voler riaprire la stanza "${roomClosureModal.room.name}" per il giorno ${roomClosureModal.day.format('DD/MM/YYYY')}?`
                        : `Sei sicuro di voler chiudere la stanza "${roomClosureModal.room.name}" per il giorno ${roomClosureModal.day.format('DD/MM/YYYY')}? Gli appuntamenti esistenti non saranno visibili.`
                    }
                </p>
            </ConfirmationModal>
        )}

        {choiceModal.isOpen && ( 
            <ChoiceModal 
                title={`Gestisci Assegnazione Multipla`}
                onChoice={handleChoice}
                onClose={() => setChoiceModal({ isOpen: false, data: null, action: null })}
                choices={[
                    { label: 'Solo per questa data', value: 'this_day_only', className: 'confirm-button' },
                    { label: 'Per questa e tutte le future', value: 'all_future', className: choiceModal.action === 'delete' ? 'warning-button' : 'neutral-button' }
                ]}>
                <p>Questo appuntamento si ripete in più giorni. Come vuoi applicare questa azione?</p>
            </ChoiceModal>
        )}

        {tooltip.visible && <Tooltip content={tooltip.content} position={{ x: tooltip.x, y: tooltip.y }} />}

        {/* Modale avviso macchinari mancanti durante swap stanza */}
        {swapEquipmentWarning.isOpen && (
            <div className="modal" onMouseDown={() => setSwapEquipmentWarning({
                isOpen: false, missingEquipment: [], pendingTarget: null
            })}>
                <div
                    className="modal-content"
                    style={{ maxWidth: '480px' }}
                    onMouseDown={e => e.stopPropagation()}
                >
                    <h3>⚠️ Stanza Non Idonea</h3>
                    <p style={{ color: '#374151', marginBottom: '12px' }}>
                        La stanza di destinazione non dispone di tutti i macchinari
                        richiesti dalle prestazioni di questo turno:
                    </p>
                    <ul style={{
                        margin: '0 0 20px 20px', padding: 0,
                        color: '#dc2626', fontWeight: '600'
                    }}>
                        {swapEquipmentWarning.missingEquipment.map(eq => (
                            <li key={eq.id}>{eq.name}</li>
                        ))}
                    </ul>
                    <p style={{ fontSize: '0.9rem', color: '#6b7280', marginBottom: '20px' }}>
                        Puoi annullare lo spostamento oppure forzarlo ignorando
                        il controllo macchinari.
                    </p>
                    <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                        {/* Annulla: chiude il modale e rimane in swap mode */}
                        <button
                            onClick={() => setSwapEquipmentWarning({
                                isOpen: false, missingEquipment: [], pendingTarget: null
                            })}
                            style={{
                                padding: '10px 20px', backgroundColor: '#6b7280',
                                color: 'white', border: 'none', borderRadius: '6px',
                                cursor: 'pointer', fontWeight: '600'
                            }}
                        >
                            Annulla
                        </button>
                        {/* Forza: prosegue lo swap ignorando i macchinari */}
                        <button
                            onClick={handleForceSwapDespiteEquipment}
                            style={{
                                padding: '10px 20px', backgroundColor: '#f59e0b',
                                color: 'white', border: 'none', borderRadius: '6px',
                                cursor: 'pointer', fontWeight: '600'
                            }}
                        >
                            ⚠️ Forza Spostamento
                        </button>
                    </div>
                </div>
            </div>
        )}

        {pasteServicesConfirm.isOpen && (
    <div className="modal-overlay" style={{ zIndex: 10000 }}>
        <div className="modal-content" style={{ maxWidth: '420px', textAlign: 'center', padding: '1.5rem' }}>
            <h4 style={{ margin: '0 0 10px' }}>📋 Incolla Prestazioni</h4>
            <p style={{ fontSize: '0.9rem', color: '#475569', margin: '0 0 20px' }}>
                Questo turno ha già delle prestazioni configurate.<br/>
                Vuoi <strong>sostituirle</strong> con quelle copiate, o <strong>aggiungerle</strong> a quelle già presenti?
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <button onClick={() => executePasteServices('replace')} style={{ padding: '10px', borderRadius: '6px', border: 'none', background: '#dc2626', color: 'white', fontWeight: 'bold', cursor: 'pointer' }}>
                    Sostituisci tutte
                </button>
                <button onClick={() => executePasteServices('merge')} style={{ padding: '10px', borderRadius: '6px', border: 'none', background: '#16a34a', color: 'white', fontWeight: 'bold', cursor: 'pointer' }}>
                    Aggiungi a quelle esistenti
                </button>
                <button onClick={() => setPasteServicesConfirm({ isOpen: false, targetAssignment: null })} style={{ padding: '10px', borderRadius: '6px', border: '1px solid #d1d5db', background: 'white', color: '#374151', cursor: 'pointer' }}>
                    Annulla
                </button>
            </div>
        </div>
    </div>
)}
        
        {isModalOpen && ( 
           <AssignmentModal 
                modalData={modalData} 
                rooms={rooms} 
                doctors={doctors} 
                services={services}
                // --- MODIFICA: Passiamo gli assignments per il controllo disponibilità ---
                assignments={assignments} 
                // -----------------------------------------------------------------------
                onSave={handleSaveAssignment} 
                onClose={() => setIsModalOpen(false)}
                allEquipment={allEquipment} 
                allSpecialties={specialties}
            />
        )}
        
                <div className={`calendar-container ${swapState.active ? 'swap-mode' : ''} ${copyServicesState.active ? 'swap-mode' : ''}`}>
            {swapState.active && (
                <div className="swap-banner">
                    <h4>Modalità Scambio Stanza</h4>
                    <p>
                        Spostando: <strong>{swapState.sourceAssignment.doctorName}</strong> ({swapState.sourceAssignment.startTime} - {swapState.sourceAssignment.endTime})
                        <br/>
                        Seleziona uno slot libero o un altro appuntamento di destinazione.
                    </p>
                    <button onClick={cancelSwap} className="cancel-swap-btn">Annulla Scambio</button>
                </div>
            )}
            {copyServicesState.active && (
                <div className="swap-banner">
                    <h4>📋 Modalità Copia Prestazioni</h4>
                    <p>
                        Copiando da: <strong>{copyServicesState.sourceAssignment.doctorName || 'Stanza Libera'}</strong> ({copyServicesState.sourceAssignment.startTime} - {copyServicesState.sourceAssignment.endTime})
                        <br/>
                        Clicca su un altro turno per incollarle, o su uno slot libero per crearne uno nuovo con le stesse prestazioni.
                    </p>
                    <button onClick={cancelCopyServices} className="cancel-swap-btn">Annulla Copia</button>
                </div>
            )}
             <div className="week-navigator">
                <button onClick={() => changeWeek(-1)}>◀ Sett. Prec.</button>
                <div className="date-picker-wrapper">
                    <h3>{currentWeek.format('DD MMM')} - {currentWeek.clone().endOf('isoWeek').subtract(1, 'day').format('DD MMM YY')}</h3>
                    <DatePicker selected={currentWeek.toDate()} onChange={handleDateChange} customInput={<button className="calendar-button" title="Seleziona una data"><FaCalendarAlt /></button>} dateFormat="dd/MM/yyyy" locale="it" />
                </div>
                <button onClick={() => changeWeek(1)}>Sett. Succ. ▶</button>
            </div>
            <div className="calendar-filters">
                {/* 🎯 FIX CHIRURGICO: Se l'utente è medico, mostriamo una finta tendina disabilitata o lo forziamo */}
                <Select 
                    options={doctorOptions} 
                    value={filteredDoctor} 
                    onChange={setFilteredDoctor} 
                    placeholder="Filtra per medico..." 
                    isClearable={!userProfile?.isDoctorProfile} // Il medico non può resettare il filtro
                    isDisabled={userProfile?.isDoctorProfile} // Il medico non può cambiarlo
                    className="calendar-select" 
                    classNamePrefix="react-select" 
                    menuPortalTarget={document.body} 
                    styles={portalStyles} 
                />
                
                {/* La tendina delle specialistiche la lasciamo usare al medico se vuole filtrare le PROPRIE specialistiche */}
                <Select 
                    options={specialtyOptions} 
                    value={filteredSpecialty} 
                    onChange={setFilteredSpecialty} 
                    placeholder="Filtra per specialistica..." 
                    isClearable 
                    className="calendar-select" 
                    classNamePrefix="react-select" 
                    menuPortalTarget={document.body} 
                    styles={portalStyles} 
                />
            </div>
            
            <div className="accordion summary-accordion">
                <button className={`accordion-toggle day-toggle ${isSummaryOpen ? 'open' : ''}`} onClick={() => setIsSummaryOpen(!isSummaryOpen)}>
                    <span className="day-name">Riepilogo Occupazione Settimana e Mese</span>
                </button>
                <div className={`accordion-content ${isSummaryOpen ? 'open' : ''}`}>
                     <div className="summary-grid-wrapper">
                        <div className="summary-grid-container" style={{ gridTemplateColumns: `150px repeat(${rooms.length}, 160px)` }}>
                            <div className="summary-day-label-sticky header">Giorno</div>
                            {rooms.map(room => ( <div key={room.id} className="summary-room-header">{room.name}</div> ))}
                            {daysOfWeek.map(day => {
                                const dayStr = day.format('YYYY-MM-DD');
                                const closedInfo = isDayClosed(day);
                                return (
                                    <React.Fragment key={dayStr}>
                                        <div className="summary-day-label-sticky">{day.format('ddd DD/MM')}</div>
                                        {rooms.map(room => {
                                            const daily = summaryData[room.id]?.daily[dayStr];
                                            const isRoomAlsoClosed = isRoomClosedOnDay(room.id, day);
                                            return (
                                                <div key={room.id} className="summary-data-cell">
                                                    {daily && daily.occupiedHours !== 'N/D' && !closedInfo.closed && !isRoomAlsoClosed ? (
                                                        <>
                                                            <div className="summary-hours occupied">✔️ <strong>{daily.occupiedHours}h</strong></div>
                                                            <div className="summary-hours free">❌ <strong>{daily.freeHours}h</strong></div>
                                                        </>
                                                    ) : <span className="summary-closed">Chiuso</span>}
                                                </div>
                                            );
                                        })}
                                    </React.Fragment>
                                );
                            })}

                            <React.Fragment>
                                <div className="summary-day-label-sticky footer">RIEPILOGO SETT.</div>
                                {rooms.map(room => {
                                    const weekly = summaryData[room.id]?.weekly;
                                    const percentage = weekly && weekly.totalMinutes > 0 ? ((weekly.occupiedMinutes / weekly.totalMinutes) * 100).toFixed(0) : 0;
                                    return (
                                        <div key={room.id} className="summary-data-cell monthly-percentage">
                                            <strong>{percentage}%</strong>
                                            <span>Occupazione</span>
                                        </div>
                                    );
                                })}
                            </React.Fragment>

                            <React.Fragment>
                                <div className="summary-day-label-sticky footer">RIEPILOGO MESE</div>
                                {rooms.map(room => {
                                    const monthly = summaryData[room.id]?.monthly;
                                    const percentage = monthly && monthly.totalMinutes > 0 ? ((monthly.occupiedMinutes / monthly.totalMinutes) * 100).toFixed(0) : 0;
                                    return (
                                        <div key={room.id} className="summary-data-cell monthly-percentage">
                                            <strong>{percentage}%</strong>
                                            <span>Occupazione</span>
                                        </div>
                                    );
                                })}
                            </React.Fragment>
                        </div>
                     </div>
                </div>
            </div>

            {isLoading ? <p>Caricamento calendario...</p> : (
                isFilterActive ? (
                     <div className="filtered-view-container">
                        <h4>Appuntamenti per la settimana del {currentWeek.format('DD MMMM')}</h4>
                        <div className="filtered-cards-grid">
                            {weeklyFilteredOccurrences.map(({ actualDate, assignment }, index) => (
                                <div key={`${assignment.id}-${index}`} className="filtered-card-item">
                                    <div className="filtered-card-header">
                                        <span className="filtered-card-day">{actualDate.format('dddd DD/MM')}</span>
                                        <span className="filtered-card-time">{assignment.startTime} - {assignment.endTime}</span>
                                    </div>
                                    <div className="filtered-card-body">
                                        <div className="filtered-card-doctor">{assignment.doctorName}</div>
                                        <div className="filtered-card-room">Stanza: <strong>{assignment.roomName}</strong></div>
                                        <div className="tag-container">
                                            {(assignment.doctorSpecialties || []).map(spec => 
                                                <span key={spec.id} className="tag-pill" style={{ backgroundColor: spec.color, color: 'white' }}>{spec.name}</span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        {weeklyFilteredOccurrences.length === 0 && <p className="no-results-message">Nessun appuntamento trovato per i filtri selezionati in questa settimana.</p>}
                    </div>
                ) : (
                    <div className="days-accordions-container">
                        {daysOfWeek.map((day, index) => {
                            const dayKey = day.isoWeekday();
                            const dayHours = businessHours[dayKey];
                            const closedInfo = isDayClosed(day);
                            return (
                                <div key={day.format('YYYY-MM-DD')} id={`day-accordion-${day.format('YYYY-MM-DD')}`} className="accordion">
                                    <button className={`accordion-toggle day-toggle ${openAccordions[index] ? 'open' : ''} ${closedInfo.closed ? 'closed' : ''}`} onClick={() => toggleAccordion(index)}>
                                        <span className="day-name">{day.format('dddd')}</span>
                                        <span className="day-date">{day.format('DD/MM')}</span>
                                    </button>
                                    <div className={`accordion-content ${openAccordions[index] ? 'open' : ''}`}>
                                        {closedInfo.closed ? (
                                            <div className="holiday-message-container">{closedInfo.reason}</div>
                                        ) : (
                                            <div className="rooms-body-scrollable">
                                                <div className="rooms-header">{rooms.map(room => ( <div key={room.id} className={`room-header-cell ${canEdit ? 'editable' : ''}`} onClick={() => canEdit && setRoomClosureModal({isOpen: true, room: room, day: day})} onMouseEnter={(e) => handleMouseEnterRoom(e, room)} onMouseLeave={handleMouseLeaveRoom}> {room.name} </div> ))}</div>
                                                <div className="rooms-body">
                                                    {rooms.map(room => {
                                                        const isRoomClosed = isRoomClosedOnDay(room.id, day);
                                                        if (isRoomClosed) return (<div key={room.id} className="room-column closed"><div className="room-closed-message">CHIUSA</div></div>);
                                                        if (!dayHours) return <div key={room.id} className="room-column" style={{ justifyContent: 'center', alignItems: 'center' }}><span style={{ color: '#aaa', fontSize: '0.9rem' }}>Chiuso</span></div>;
                                                        
                                                        const { open: openingTime, close: closingTime } = dayHours;
                                                        const assignmentsForRoomAndDay = filteredAssignments.filter(a => a.roomId === room.id && (a.daysOfWeek || []).includes(dayKey) && !(a.excludedDates || []).includes(day.format('YYYY-MM-DD')) && moment(day).isBetween(a.validFrom, a.validUntil, 'day', '[]') && (!a.isRecurring || day.diff(moment(a.validFrom).startOf('isoWeek'), 'weeks') % a.recurrenceInterval === 0)).sort((a, b) => a.startTime.localeCompare(b.startTime));
                                                        const slots = [];
                                                        let lastEndTime = openingTime;
                                                        assignmentsForRoomAndDay.forEach(assign => {
                                                            if (assign.startTime > lastEndTime) slots.push({ type: 'free', startTime: lastEndTime, endTime: assign.startTime });
                                                            slots.push({ type: 'busy', data: assign });
                                                            lastEndTime = assign.endTime;
                                                        });
                                                        if (lastEndTime < closingTime) slots.push({ type: 'free', startTime: lastEndTime, endTime: closingTime });
                                                        
                                                        return (
                                                            <div key={room.id} className="room-column">
                                                                {slots.map((slot, i) => slot.type === 'busy' ? (
                                                                    <div 
                                                                        key={slot.data.id} 
                                                                        className={`assignment-card ${canEdit && !swapState.active ? 'editable' : ''} ${swapState.active && 'is-swap-target'} ${swapState.active && swapState.sourceAssignment?.id === slot.data.id && 'is-swap-source'}`}
                                                                        // 🎯 MODIFICA 1: Sfondo grigio se l'ID è nell'array closedSessionsList
                                                                        style={(() => {
                                                                            // 🆕 Stile in base allo stato di chiusura (priorità massima)
                                                                            const closure = getClosureStatus(slot.data, day.format('YYYY-MM-DD'), closedSessionsList);
                                                                            if (closure.state === 'full') {
                                                                                // Chiusura TOTALE: card spenta
                                                                                return { backgroundColor: '#f8fafc', borderLeft: '5px solid #94a3b8', opacity: 0.75 };
                                                                            }
                                                                            if (closure.state === 'partial') {
                                                                                // Chiusura PARZIALE: turno attivo, ma segnalato in arancione
                                                                                return { backgroundColor: '#fffbeb', borderLeft: '5px solid #f59e0b' };
                                                                            }
                                                                            // In swap mode, coloro la card in base ai macchinari della stanza
                                                                            if (swapState.active && swapState.sourceAssignment?.id !== slot.data.id) {
                                                                                const req = getSwapRequiredEquipment(swapState.sourceAssignment);
                                                                                if (req.length) {
                                                                                    const { suitable } = checkRoomEquipmentSuitability(room, req);
                                                                                    return suitable
                                                                                        ? { borderLeft: '4px solid #16a34a', backgroundColor: '#f0fdf4' }
                                                                                        : { borderLeft: '4px solid #dc2626', backgroundColor: '#fef2f2' };
                                                                                }
                                                                            }
                                                                            return {};
                                                                        })()}
                                                                            onClick={() => {
                                                                            if (!canEdit) return;
                                                                            if (swapState.active && swapState.sourceAssignment?.id !== slot.data.id) {
                                                                                handleTargetSlotClick({ type: 'busy', assignment: slot.data, day: day });
                                                                            } else if (copyServicesState.active && copyServicesState.sourceAssignment?.id !== slot.data.id) {
                                                                                handlePasteOnAssignment(slot.data);
                                                                            } else if (!swapState.active && !copyServicesState.active) {
                                                                                openModal(day, slot.data);
                                                                            }
                                                                        }}
                                                                    >
                                                                        {/* 🆕 Etichetta chiusura: totale vs parziale (con elenco fasce) */}
                                                                        {(() => {
                                                                            const closure = getClosureStatus(slot.data, day.format('YYYY-MM-DD'), closedSessionsList);
                                                                            if (closure.state === 'open') return null;

                                                                            if (closure.state === 'full') {
                                                                                return (
                                                                                    <div style={{ fontSize: '0.7rem', color: '#dc2626', fontWeight: '900', marginBottom: '4px' }}>
                                                                                        🚫 SEDUTA CHIUSA DA AGENDA
                                                                                    </div>
                                                                                );
                                                                            }

                                                                            // Parziale: elenca le fasce chiuse
                                                                            return (
                                                                                <div style={{ marginBottom: '6px' }}>
                                                                                    <div style={{ fontSize: '0.7rem', color: '#b45309', fontWeight: '900', marginBottom: '3px' }}>
                                                                                        ⚠️ CHIUSURA PARZIALE
                                                                                    </div>
                                                                                    {closure.intervals.map((iv, idx) => (
                                                                                        <div key={idx} style={{
                                                                                            fontSize: '0.66rem', color: '#92400e', fontWeight: 700,
                                                                                            backgroundColor: '#fef3c7', border: '1px solid #fde68a',
                                                                                            borderRadius: '4px', padding: '1px 5px', marginBottom: '2px',
                                                                                            display: 'flex', justifyContent: 'space-between', gap: '6px',
                                                                                        }}>
                                                                                            <span>{iv.startTime}–{iv.endTime}</span>
                                                                                            <span style={{ textTransform: 'capitalize', opacity: 0.85 }}>
                                                                                                {(iv.reason || 'altro').replace(/_/g, ' ')}
                                                                                                {iv.paidAnyway === true ? ' 💰' : ''}
                                                                                            </span>
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                            );
                                                                        })()}
                                                                        <div className="assignment-time">{slot.data.startTime} - {slot.data.endTime}</div>
                                                                        <div className="specialty-indicators">{(slot.data.doctorSpecialties || []).map(spec => (<span key={spec.id} className="specialty-dot" style={{ backgroundColor: spec.color }} title={spec.name}></span>))}</div>
                                                                        <div className="assignment-specialty-list">{(slot.data.doctorSpecialties || []).map(s => <div key={s.id}>{s.name}</div>)}</div>
                                                                        <div className="assignment-doctor-wrapper">
                                                                            <span className="assignment-doctor">{slot.data.doctorName}</span>
                                                                            {slot.data.collaboratorIds && slot.data.collaboratorIds.length > 0 && (<span className="collaborator-plus" onMouseEnter={(e) => handleMouseEnterCollaborator(e, slot.data.collaboratorIds)} onMouseLeave={handleMouseLeaveRoom}>+</span>)}
                                                                        </div>
                                                                                                                                                {canEdit && !swapState.active && !copyServicesState.active && (
                                                                            <div className="card-actions-toolbar">
                                                                                <button onClick={(e) => { e.stopPropagation(); initiateSwap(slot.data, day); }} className="action-btn swap-btn" title="Scambia Stanza">🔁</button>
                                                                                <button onClick={(e) => { e.stopPropagation(); initiateCopyServices(slot.data); }} className="action-btn copy-services-btn" title="Copia Prestazioni">📋</button>
                                                                                <button onClick={(e) => { e.stopPropagation(); handleDeleteAssignment(slot.data, day); }} className="action-btn delete-btn" title="Elimina">×</button>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                ) : (
                                                                    <div 
                                                                        key={`free-${i}`} 
                                                                        className={`free-slot-card ${canEdit ? 'editable' : ''} ${swapState.active && 'is-swap-target'}`}
                                                                        style={(() => {
                                                                            // In swap mode, coloro la stanza in base alla disponibilità macchinari
                                                                            if (!swapState.active) return {};
                                                                            const req = getSwapRequiredEquipment(swapState.sourceAssignment);
                                                                            if (!req.length) return {}; // Nessun macchinario richiesto: neutro
                                                                            const { suitable } = checkRoomEquipmentSuitability(room, req);
                                                                            return suitable
                                                                                ? { borderLeft: '4px solid #16a34a', backgroundColor: '#f0fdf4' }
                                                                                : { borderLeft: '4px solid #dc2626', backgroundColor: '#fef2f2' };
                                                                        })()}
                                                                            onClick={() => {
                                                                            if (!canEdit) return;
                                                                            // 🎯 La Copia Prestazioni funziona solo su turni già esistenti:
                                                                            // click su uno slot libero durante la modalità copia non fa nulla.
                                                                            if (copyServicesState.active) return;
                                                                            if (swapState.active) {
                                                                                handleTargetSlotClick({ type: 'free', room: room, day: day, startTime: slot.startTime, endTime: slot.endTime });
                                                                            } else {
                                                                                openModal(day, null, slot, room.id);
                                                                            }
                                                                        }}
                                                                    >
                                                                        Libero <span className="free-slot-time">{slot.startTime} - {slot.endTime}</span>
                                                                    </div>
                                                                ))}
                                                                {canEdit && !swapState.active && (<button className="add-assignment-btn" onClick={() => openModal(day, null, null, room.id)}>+ Assegna</button>)}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )
            )}
        </div>
    </>
);
}

export default WeeklyCalendarView;